import { createSelector } from 'reselect';

import { getUserProfile, User } from '@topconagriculture/profiling';

import { RootState } from '../../reducers';
import { Company } from './company.types';

export const getCompanies = (state: RootState): Company[] => state.entities.companies;

export const getSortedCompanies = createSelector(getCompanies, (companies: Company[]) =>
  companies.sort((c1, c2) => c1.companyName.localeCompare(c2.companyName)),
);

export const hasOtherUsersCompanies = createSelector(
  [getCompanies, getUserProfile],
  (companies: Company[], user: User | null) =>
    companies.filter((company) => company.id !== user?.company?.id).length > 0,
);
